import { Box, Card, CardContent, Typography, TextField, Button } from '@mui/material';
import { User as UserIcon } from 'lucide-react';
import {} from '@lingaai/shared-hooks';
import { useCurrentUser } from '@lingaai/user-management';
import { ICON_SIZES, ICON_STROKE } from '../../constants/icons';

export function UserInfo() {
  const { data: user, isLoading } = useCurrentUser();

  if (isLoading) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>Loading user information...</Typography>
      </Box>
    );
  }

  if (!user) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">No user information available.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 800 }}>
      {/* User Information */}
      <Card>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
            <UserIcon size={ICON_SIZES.lg} strokeWidth={ICON_STROKE} />
            <Typography variant="h6">User Information</Typography>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
            <Box>
              <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
                First Name
              </Typography>
              <TextField fullWidth value={user.first_name || ''} disabled size="small" />
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
                Last Name
              </Typography>
              <TextField fullWidth value={user.last_name || ''} disabled size="small" />
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
                Email
              </Typography>
              <TextField fullWidth value={user.email || ''} disabled size="small" />
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
                Organization
              </Typography>
              <TextField fullWidth value={user.organization || ''} disabled size="small" />
            </Box>
          </Box>

          <Box sx={{ mt: 3, pt: 3, borderTop: 1, borderColor: 'divider' }}>
            <Button variant="outlined" disabled>
              Edit Profile
            </Button>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
              Profile editing coming soon
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
